import React from "react";
import Select from "react-select";
import { reginmenFiscalOptions } from "../../../data/regimenFiscalData";
import FilterToggle from "../../atoms/FilterToggle";

const EmpresaListSearch = ({ filters, setFilters }) => {
    const handleChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    return (
        <FilterToggle>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                <input
                    type="text"
                    placeholder="Buscar por empresa"
                    name="empresa"
                    value={filters.empresa}
                    onChange={handleChange}
                    className="border p-2 rounded w-full"
                />
                <input
                    type="text"
                    placeholder="Buscar por RFC"
                    name="rfc"
                    value={filters.rfc}
                    onChange={handleChange}
                    className="border p-2 rounded w-full"
                />
                <input
                    type="text"
                    placeholder="Buscar por contador"
                    name="contador"
                    value={filters.contador}
                    onChange={handleChange}
                    className="border p-2 rounded w-full"
                />
                <Select
                    name="regimenFiscal"
                    options={reginmenFiscalOptions}
                    isMulti
                    placeholder="Régimen Fiscal"
                    value={reginmenFiscalOptions.filter(opt => filters.regimenFiscal.includes(opt.value))}
                    onChange={(selected) =>
                        setFilters({
                        ...filters,
                        regimenFiscal: selected.map((opt) => opt.value),
                        })
                    }
                    className="w-full"
                />
            </div>
        </FilterToggle>
    );
};

export default EmpresaListSearch;